import { http } from "../api/http";
import Utils from "../utils";

export const runbookConnectorService = {
  get,
  create,
  remove,
};

async function get(requestParameters) {
  let url = `/runbookconnector?${Utils.objectToQueryString(requestParameters)}`;

  const response = await http.get(url);
  return response;
}

async function create(requestBody) {
  let url = `/runbookconnector/create`;

  const response = await http.post(url, JSON.stringify(requestBody));
  return response;
}

async function remove(requestParameters) {
  let url = `/runbookconnector/delete?${Utils.objectToQueryString(
    requestParameters
  )}`;

  const response = await http.delete(url);
  return response;
}
